import { DispatchAreaOption } from '@mark43/cad-api';
import React from 'react';

export type LocationBiasContextValue = {
    dispatchAreaOptions: DispatchAreaOption[];
    setLocationBiasId: React.Dispatch<number | undefined> | undefined;
    locationBias: DispatchAreaOption | undefined | null;
};

export const LocationBiasContext = React.createContext<LocationBiasContextValue>({
    dispatchAreaOptions: [],
    locationBias: undefined,
    setLocationBiasId: undefined,
});
